import { memo } from 'react';
import { LOGO_LIGHT } from '@/lib/constants';

interface PageTransitionProps {
  state: 'hidden' | 'entering' | 'exiting';
}

export const PageTransition = memo(({ state }: PageTransitionProps) => {
  let transformClass = 'translate-y-full';
  if (state === 'entering') transformClass = 'translate-y-0';
  if (state === 'exiting') transformClass = '-translate-y-full';
  if (state === 'hidden') transformClass = 'translate-y-full';
  
  const isHidden = state === 'hidden';

  return (
    <div 
      className={`fixed inset-0 z-[100] bg-black pointer-events-none flex items-center justify-center text-white
        ${isHidden ? 'transition-none duration-0' : 'transition-transform duration-1000 ease-curtain'}
        ${transformClass}
      `}
      style={{ 
        willChange: isHidden ? 'auto' : 'transform',
        backfaceVisibility: 'hidden',
        transform: `translate3d(0, ${state === 'entering' ? '0' : state === 'exiting' ? '-100%' : '100%'}, 0)`,
      }}
    >
      <img src={LOGO_LIGHT} alt="Go4It Logo" className="w-48 md:w-56 h-auto animate-pulse object-contain" width={224} height={96} />
    </div>
  );
});

PageTransition.displayName = 'PageTransition';
